import React, { useEffect, useState } from "react";
import TechCard from "./TechCard";
import { categorizedTechnologies } from "./techData";
import axios from "axios";
import API_BASE_URL from "../Config/config";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TechGrid = () => {
  const navigate = useNavigate();
  const [progressData, setProgressData] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId || "Guest";

  useEffect(() => {
    const fetchProgressForAllTech = async () => {
      const allProgress = {};

      await Promise.all(
        Object.values(categorizedTechnologies).flat().map(async (tech) => {
          const techTitle = tech.title;
          try {
            const res = await axios.get(
              `${API_BASE_URL}/get-passed-levels/${userId}/${encodeURIComponent(techTitle)}`
            );
            allProgress[techTitle] = res.data.passedLevels || [];
          } catch (err) {
            allProgress[techTitle] = [];
          }
        })
      );

      setProgressData(allProgress);
    };

    if (userId !== "Guest") {
      fetchProgressForAllTech();
    }
  }, [userId]);

  return (
    <div className="min-h-screen bg-bgMain p-8 relative overflow-hidden font-sans">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl -ml-48 -mb-48"></div>

      <div className="flex items-center gap-6 mb-12 relative z-10">
        <button
          onClick={() => navigate("/dashboard")}
          className="p-3 bg-white border-2 border-primary/10 rounded-2xl text-primary hover:border-primary hover:bg-primary/5 transition-all shadow-lg shadow-primary/5 group"
          title="Back to Dashboard"
        >
          <ArrowLeft size={24} className="group-hover:-translate-x-1 transition-transform" />
        </button>
        <h1 className="text-5xl font-extrabold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent uppercase tracking-tighter">
          Technologies
        </h1>
      </div>

      {Object.entries(categorizedTechnologies).map(([category, techList]) => (
        <div key={category} className="mb-16 relative z-10">
          <div className="flex items-center gap-4 mb-8">
            <div className="h-10 w-2 bg-gradient-to-b from-primary to-accent rounded-full"></div>
            <h2 className="text-3xl font-black text-midnight uppercase tracking-widest">{category}</h2>
          </div>
          <div className="flex flex-wrap gap-8 justify-start">
            {techList.map((tech, index) => {
              const practiceLink = tech.link?.split("/questions/")[1] || "";
              const completedLevels = progressData[tech.title]?.length || 0;

              return (
                <TechCard
                  key={index}
                  title={tech.title}
                  description={tech.description}
                  image={tech.image}
                  practiceLink={practiceLink}
                  completedLevels={completedLevels}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TechGrid;



